import { CommonModule } from '@angular/common';
import {
  Component, OnDestroy, computed, inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { ToastComponent, ToastService } from '@instaclause-webapp/shared-ui';
import { Subscription } from 'rxjs';

import { SupportModeService } from '../../core/support-mode.service';
import { MenuComponent } from '../../ui/menu/menu.component';
import { SupportBannerComponent } from '../../ui/support-banner/support-banner.component';

@Component({
  selector: 'app-main-layout',
  imports: [ CommonModule, MenuComponent, RouterModule, SupportBannerComponent, ToastComponent ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent implements OnDestroy {
  openToastsCount = computed(() => this.toastService.toasts().length);

  readonly supportMode = inject(SupportModeService);

  private subscription = new Subscription();
  private toastService = inject(ToastService);

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
